var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlertDiamond(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0923 6.21678L7.78312 0.907571C7.35057 0.475145 6.64939 0.475145 6.21684 0.907571L0.907632 6.21733C0.475207 6.64989 0.475207 7.35106 0.907632 7.78362L6.21684 13.0923C6.64939 13.5247 7.35057 13.5247 7.78312 13.0923L13.0923 7.78362C13.3002 7.57587 13.4169 7.29405 13.4169 7.0002C13.4169 6.70634 13.3002 6.42452 13.0923 6.21678ZM6.41667 4.01033C6.41667 3.72844 6.67783 3.49992 7 3.49992C7.32217 3.49992 7.58333 3.72844 7.58333 4.01033V7.07283C7.58333 7.35473 7.32217 7.58325 7 7.58325C6.67783 7.58325 6.41667 7.35473 6.41667 7.07283V4.01033ZM7.02975 10.4999H7.01342C6.53555 10.4981 6.14404 10.1199 6.1256 9.64242C6.11695 9.41142 6.2016 9.18666 6.36049 9.01877C6.51938 8.85088 6.73914 8.75399 6.97025 8.74992H6.98658C7.46469 8.75115 7.85655 9.12963 7.8744 9.60742C7.88305 9.83841 7.7984 10.0632 7.63951 10.2311C7.48062 10.399 7.26087 10.4958 7.02975 10.4999Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertDiamond);
export default __webpack_public_path__ + "static/media/alert-diamond.86ff8234.svg";
export { ForwardRef as ReactComponent };